import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import urls from "../../config/urls"
import State from "../../ducks/state"
import {REALM_HEADER} from "../../config/constants"
import {updateFavouritesInState} from "../../ducks/favourites"

export const mapStateToProps = (state: State) => {
    const {
        request: {siteUrl, headers, cleanSiteUrl},
        settings: {variant, iconsVersionPath, isTpSuperLite},
        favourites: {hasFavourites, enableFavourites},
        template,
    } = state
    const {favourites} = urls
    const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {
        text: {
            favourites: {altText},
        },
    } = state

    return {
        altText,
        enableFavourites,
        favouritesUrl: `${isTpSuperLite ? cleanSiteUrl : siteUrl}${favourites.url}`,
        hasFavourites,
        templating: template,
        realm,
        variant,
        iconsVersionPath,
    }
}

export const mapDispatchToProps = dispatch => ({
    updateFavourites: (data: any) => {
        dispatch(updateFavouritesInState(data))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
